import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer, Legend } from 'recharts'
import { useTranslation } from '@fareye/common'
import { startCase } from '@fareye/utils'
import { Span } from '@fareye/ui'

export const PieGraph = React.memo(({ data, metric = [], sumOfTrips }: any) => {
  const { t } = useTranslation()

  data = metric.map((key: any) => {
    return { name: t(startCase(key.label)), value: data[key.matchParam] }
  })
  metric = metric.map((key: any) => {
    return {
      name: t(startCase(key.label)),
      value: data[key.matchParam],
      color: key.color
    }
  })
  metric.forEach((value: { label: any }) => {
    value.label = t(value.label)
  })
  return (
    <div style={{ height: 150, width: 270 }}>
      <ResponsiveContainer>
        <PieChart>
          <text
            x={75}
            y={70}
            dy={8}
            textAnchor="middle"
            style={{ fontSize: 12 }}
            fill={'#000'}
          >
            {t('Total Trips')}
          </text>
          <text
            x={75}
            y={84}
            dy={8}
            textAnchor="middle"
            style={{ fontSize: 12 }}
            fill={'#000'}
          >
            {sumOfTrips}
          </text>
          <Legend
            align="right"
            layout="vertical"
            verticalAlign="middle"
            iconType="circle"
            iconSize={10}
            formatter={(value, entry: any, index) => {
              const { name, percent, value: labelValue } = entry.payload
              return (
                <>
                  {labelValue ? labelValue : 0}
                  <Span>{` ${name} (${
                    percent ? (percent * 100).toFixed() : 0
                  }%)`}</Span>
                </>
              )
            }}
          ></Legend>
          <Pie
            key={'123'}
            data={data}
            innerRadius={40}
            outerRadius={55}
            startAngle={0}
            endAngle={360}
            dataKey={'value'}
            style={{}}
          >
            {metric.map((entry: any, index: number) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
})
